export const CONST_LIST_AGENCY = {
  ISSUANCE_AGENCY: '代理店アカウント発行',
  HOLDER_NAME_OR_ID: '氏名もしくは代理店コードを入力',
  //
  AGENCY_NAME: '企業名',
  AGENCY_CODE: '代理店コード',
  REPRESENTATIVE_NAME: '代表者名',
  PHONE_NUMBER: '電話番号',
  EMAIL_ADDRESS: 'メールアドレス',
  //
  USED: '利用中',
  NOT_USED: '未利用',
  //
  REQUIRE_DOCUMENT: '導入企業一覧',
  AGENCY_ID: '企業ID',
  COMPANY_NAME: '会社名',
  INTRODUCED_DATE: '導入日',
  INFORMATION: '利用情報',
  EDIT: '編　集',
  DELETE: '削　除',
  LAST_UPDATE: '最終更新',
  SECURITY: '代理',
  CONFIRM_DELETE: '選択した代理店を本当に削除しますか？',
};
